import { useState, useEffect, useRef } from 'react'
import { Button, Dropdown, Table } from 'react-bootstrap';
import Api from 'helpers/Api';
import Loader from 'components/misc/Loader';
import moment from 'moment';
import NoDataFound from 'components/misc/NoDataFound';
import Pagination from 'components/misc/Pagination';
import TableHeader from 'components/misc/TableHeader';
import TableCol from 'components/misc/TableCol';
import PriceValue from 'components/partials/PriceValue';
import MenuOptions from 'components/misc/MenuOptions';
import { Navigate, useNavigate } from 'react-router-dom';

function Index(props) {

    const navigate = useNavigate();

    const defaultData = [];

    const tableRef = useRef(null);

    const [state, setState] = useState({
        data: defaultData,
        pages: 0,
        total: 0,
        loading: false,
        filter: {
            page: 1,
        },
        refresh: false,
    });

    useEffect(() => {

        loading(true);

        Api.get('accounts/invoices', {
            params: {
                id: props.id,
                ...state.filter,
            }
        }).then(res => {
            setState(prev => ({
                ...prev,
                data: res.data.items,
                total: res.data.total,
                pages: res.data.pages,
                filter: {
                    ...prev.filter,
                    ...res.data.filter,
                },
            }));

            if (res.data.pages > 0 && state.filter.page > res.data.pages) {
                return handlePage({ selected: res.data.pages - 1 });
            }

            loading(false);
            sorting(false);
        });
    }, [props.id, state.refresh]);

    const loading = (loading) => {
        setState(prev => ({
            ...prev,
            loading: Boolean(loading)
        }));
    }

    const sorting = (sorting) => {
        setState(prev => ({
            ...prev,
            sorting: Boolean(sorting)
        }));
    }

    const handlePage = page => {
        setState(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                page: page.selected + 1,
            },
            refresh: new Date()
        }));
    }

    const handleSort = (sort, order) => {
        setState(prev => ({
            ...prev,
            sorting: true,
            filter: {
                ...prev.filter,
                sort: sort,
                order: order,
                page: 1,
            },
            refresh: new Date().getTime()
        }));
    }

    const handleShow = id => {
        props.showInvoice(id);
    }

    const handleAdd = () => {
        navigate('/invoices/new?from_account_id=' + props.id);
    }

    const handleEdit = id => {
        navigate('/invoices/' + id + '/edit');
    }

    const handleDelete = id => {
        props.deleteInvoice(id);
    }

    return (

        state.loading && !state.sorting
            ?
            <Loader />
            :
            state.data.length === 0 ?
                <NoDataFound>
                    <div>
                        Няма намерена информация!
                    </div>
                    {/* <br />
                    <Button variant="outline-dark" onClick={e => handleAdd()}>
                        Нов документ
                    </Button> */}
                </NoDataFound>
                :
                <>
                    <Table className="big" striped ref={tableRef}>
                        <TableHeader
                            tableRef={tableRef}
                            activeSortKey={state.filter.sort}
                            activeSortDir={state.filter.order}
                            onSort={(col, dir) => handleSort(col, dir)}
                        >
                            <TableCol sortable sortKey="id" style={{ width: '5%' }}>ID</TableCol>
                            <TableCol sortable sortKey="type">Тип</TableCol>
                            <TableCol className="text-right" sortable sortKey="no">Номер</TableCol>
                            <TableCol sortable sortKey="date">Дата</TableCol>
                            <TableCol sortable sortKey="receiver_company_name">Получател</TableCol>
                            <TableCol sortable sortKey="seller_company_name">Доставчик</TableCol>
                            <TableCol className="text-left" sortable sortKey="paymethod">Вид плащане</TableCol>
                            <TableCol className="text-right" sortable sortKey="gross_price">Тотал</TableCol>
                            <TableCol className="text-center" sortable sortKey="status">Статус</TableCol>
                            <TableCol className="options">Опции</TableCol>
                        </TableHeader>
                        <tbody>
                            {state.data.map((r, i) =>
                                <tr key={i}>
                                    <td>
                                        {r.id}
                                    </td>
                                    <td>
                                        {r.type?.name}
                                    </td>
                                    <td className="text-right">
                                        {r.no}
                                    </td>
                                    <td>
                                        {r.date ? moment(r.date).format('DD.MM.YYYY') : ''}
                                    </td>
                                    <td>
                                        {r.receiver_company_name}
                                    </td>
                                    <td>
                                        {r.seller_company_name}
                                    </td>
                                    <td>
                                        {r.paymethod?.name}
                                    </td>
                                    <td className={`text-right ${r.gross_price < 0 && 'negative-value'}`}>
                                        <PriceValue prefix={r.currency?.prefix} sufix={r.currency?.sufix}>{r.gross_price}</PriceValue>
                                    </td>
                                    <td className={`text-center ${r.deleted ? 'negative-value' : 'positive-value'}`}>
                                        {r.deleted ? 'Анулирана' : 'Издадена'}
                                    </td>
                                    <td className="options">
                                        <MenuOptions>
                                            <Dropdown.Item onClick={e => handleShow(r.id)}>
                                                Преглед
                                            </Dropdown.Item>
                                            {r.allow_edit &&
                                                <Dropdown.Item onClick={e => handleEdit(r.id)}>
                                                    Редакция
                                                </Dropdown.Item>
                                            }
                                            <Dropdown.Item onClick={e => handleDelete(r.id)}>
                                                Разкачване
                                            </Dropdown.Item>
                                        </MenuOptions>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>

                    <Pagination
                        page={state.filter.page}
                        pages={state.pages}
                        handlePage={handlePage}
                    />
                </>
    )
}

export default Index;